<template>
  <div class="ticket-entry-container" v-loading="state.loading">
    <!-- 头部导航 -->
    <header class="header">
      <button class="back-btn" @click="handleBack" aria-label="返回">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.5 5L7.5 10L12.5 15"
            stroke="#333"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <h1 class="title">票码核销</h1>
      <div class="header-right"></div>
    </header>

    <!-- 入园码区域 -->
    <div class="entry-code-section">
      <div class="code-container">
        <!-- 二维码区域 - 添加了装饰效果 -->
        <div class="qrcode-container">
          <div class="qrcode-wrapper">
            <div class="qrcode-content">
              <!-- 二维码加载状态 -->
              <div v-if="!state.qrCodeUrl" class="loading-spinner"></div>
              <!-- 二维码图片 -->
              <img
                v-else
                :src="state.qrCodeUrl"
                alt="入园二维码"
                class="qr-code-image"
                :style="{
                  width: state.qrCodeSize + 'px',
                  height: state.qrCodeSize + 'px',
                }"
                loading="lazy"
              />
              <div class="qrcode-footer">
                <span class="qrcode-text">请向工作人员出示此码</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="info-item">
      <div class="info-label">使用日期</div>
      <div class="info-value refund-value">
        {{ formatDate(state.orderInfo?.Mxs?.[0]?.Syrq || "-") }}
      </div>
    </div>

    <!-- 入园地址 -->
    <div class="info-card">
      <div class="info-item">
        <div class="info-label">入园地址</div>
        <div class="info-value address-value">
          {{ state.orderInfo?.Mxs?.[0]?.spdz || "-" }}
        </div>
      </div>
    </div>

    <!-- 订单信息 -->
    <div class="info-card">
      <div class="info-item">
        <div class="info-label">订单编号</div>
        <div class="info-value">{{ state.orderInfo.Bh || "-" }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { shangpindingdan_detailAny } from "@/http/api";
import { dayjs } from "element-plus";
export default {
  name: "H5TicketEntry",
  setup() {
    const route = useRoute();
    const query = reactive({});
    const state = reactive({
      loading: false,
      qrCodeUrl: "", // 二维码图片URL
      qrCodeSize: 200, // 二维码大小
      orderInfo: {},
      shareUrl: "", // 分享链接
    });

    const copySuccess = ref(false);

    // 获取订单详情
    const loadOrderDetail = async () => {
      state.loading = true;
      console.log("API请求参数:", route.params.orderId, query.ph, query._t);
      shangpindingdan_detailAny(route.params.orderId, query.ph, query._t)
        .then((res) => {
          console.log("API响应状态:", res.status);
          console.log("API响应数据:", res.data);
          if (res.status === 200) {
            state.orderInfo = res.data;
            console.log("设置订单数据后:", state.orderInfo);
            // 计算总金额
            state.orderInfo.TotalPrice = res.data.Mxs.reduce((sum, item) => {
              return sum + (item.Xsdj || 0) * (item.Sl || 0);
            }, 0);
            state.shareUrl = state.orderInfo.OTAQrcodeUrl;
            generateQRCode();
          }
        })
        .finally(() => {
          state.loading = false;
        });
    };

    // 生成二维码
    const generateQRCode = async () => {
      try {
        state.qrCodeUrl = state.shareUrl;
      } catch (error) {
        console.error("生成二维码失败:", error);
        // 实际项目中应该有错误处理逻辑
      }
    };

    // 返回上一页
    const handleBack = () => {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        // 没有历史记录时的处理
        console.log("返回首页或其他处理");
      }
    };

    // 参与调研
    const handleSurvey = () => {
      console.log("参与调研功能");
      // 实际项目中可以跳转到调研页面
    };

    // 格式化日期
    const formatDate = (dateStr) => {
      return dateStr ? dayjs(dateStr).format("YYYY-MM-DD HH:mm") : "-";
    };

    // 页面加载时生成二维码
    onMounted(() => {
      query.ph = route.query.ph;
      query._t = route.query._t;
      loadOrderDetail();

      // 适配不同屏幕大小的二维码尺寸
      const updateQrCodeSize = () => {
        const screenWidth = window.innerWidth;
        // 确保二维码在各种屏幕上都有合适的大小
        state.qrCodeSize = Math.min(screenWidth * 0.6, 240);
      };

      // 初始化二维码大小
      updateQrCodeSize();

      // 监听窗口大小变化
      window.addEventListener("resize", updateQrCodeSize);

      // 清理事件监听
      return () => {
        window.removeEventListener("resize", updateQrCodeSize);
      };
    });

    return {
      state,
      copySuccess,
      handleBack,
      handleSurvey,
      formatDate,
    };
  },
};
</script>

<style scoped>
/* CSS变量定义 - 便于主题管理 */
:root {
  --primary-color: #ff9500;
  --primary-dark: #e68600;
  --secondary-color: #f5f5f5;
  --text-primary: #333333;
  --text-secondary: #666666;
  --text-tertiary: #999999;
  --success-color: #4cd964;
  --warning-color: #ffcc00;
  --danger-color: #ff3b30;
  --border-radius: 12px;
  --shadow-light: 0 2px 8px rgba(0, 0, 0, 0.08);
  --shadow-medium: 0 4px 16px rgba(0, 0, 0, 0.12);
}

/* 全局样式重置 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.ticket-entry-container {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  background-color: var(--secondary-color);
  min-height: 100vh;
  padding-bottom: 80px;
  overflow-x: hidden;
  overflow-y: auto; /* 明确允许垂直滚动 */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-overflow-scrolling: touch;
  height: 100vh; /* 确保容器高度为视口高度 */
  position: relative;
}

/* 头部导航 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.back-btn {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

.back-btn:active {
  background-color: var(--secondary-color);
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 auto;
  width: 200px;
  text-align: center;
}

.header-right {
  width: 40px; /* 为了保持标题居中 */
}

/* 信息卡片基础样式 */
.info-card {
  margin-top: 12px;
  background-color: white;
  border-radius: var(--border-radius);
  overflow: hidden;
  box-shadow: var(--shadow-light);
  animation: fadeIn 0.3s ease-out;
}

/* 门票信息 */
.ticket-info {
  margin: 16px;
  padding: 20px;
  background: linear-gradient(135deg, #fff9e6 0%, #fff4d9 100%);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-light);
  position: relative;
  overflow: hidden;
  animation: fadeIn 0.3s ease-out;
}

/* 装饰元素 */
.ticket-info::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 100px;
  height: 100px;
  background-color: rgba(255, 149, 0, 0.05);
  border-radius: 0 0 0 100%;
}

.ticket-status {
  font-size: 14px;
  font-weight: 500;
  color: var(--primary-color);
  background-color: rgba(255, 149, 0, 0.1);
  padding: 4px 12px;
  border-radius: 20px;
  display: inline-block;
  margin-bottom: 12px;
}

.ticket-name {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1.4;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
}

.ticket-name svg {
  margin-left: 8px;
  flex-shrink: 0;
}

/* 入园码区域 */
.entry-code-section {
  margin: 16px;
  background-color: white;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-light);
  animation: fadeIn 0.3s ease-out 0.1s both;
}

.section-title {
  font-size: 17px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 20px;
  text-align: center;
}

.code-container {
  position: relative;
}

.code-label {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding: 0 8px;
}

.code-label-bg {
  background-color: #f9f9f9;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 13px;
  color: var(--text-secondary);
  margin-right: 12px;
  font-weight: 500;
}

.code-value {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: 6px;
  flex: 1;
  font-family: "Courier New", monospace;
}

.copy-btn {
  background: linear-gradient(
    135deg,
    var(--primary-color) 0%,
    var(--primary-dark) 100%
  );
  border: none;
  padding: 8px 16px;
  border-radius: 24px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 70px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(255, 149, 0, 0.3);
}

.copy-btn:active {
  transform: scale(0.96);
  box-shadow: 0 1px 3px rgba(255, 149, 0, 0.2);
}

.copy-btn.copied {
  background-color: var(--success-color);
  background-image: none;
  box-shadow: 0 2px 6px rgba(76, 217, 100, 0.3);
}

/* 二维码容器 */
.qrcode-container {
  display: flex;
  justify-content: center;
}

.qrcode-wrapper {
  position: relative;
  background-color: white;
  padding: 16px;
  border-radius: 12px;
  box-shadow: var(--shadow-medium);
  transition: transform 0.3s ease;
  border: 1px solid #f0f0f0;
}

.qrcode-wrapper:active {
  transform: scale(0.98);
}

.qrcode-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qr-code-image {
  border: 1px solid #eeeeee;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.qrcode-footer {
  margin-top: 16px;
  text-align: center;
}

.qrcode-text {
  font-size: 14px;
  color: var(--text-secondary);
  font-weight: 500;
}

/* 加载动画 */
.loading-spinner {
  width: 200px;
  height: 200px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 信息项样式 */
.info-item {
  padding: 16px 20px;
  border-bottom: 1px solid #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-size: 14px;
  color: var(--text-secondary);
}

.info-value {
  font-size: 15px;
  color: var(--text-primary);
  font-weight: 500;
  text-align: right;
}

.address-value {
  max-width: 60%;
  word-break: break-word;
}

.refund-value {
  color: var(--danger-color);
}

/* 底部操作按钮 */
.bottom-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  padding: 16px;
  background-color: white;
  border-top: 1px solid #f0f0f0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 90;
}

.btn {
  flex: 1;
  padding: 14px 16px;
  border-radius: 28px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  margin: 0 8px;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}

.btn:active {
  transform: scale(0.98);
}

.btn-secondary {
  background-color: var(--secondary-color);
  color: var(--text-primary);
}

.btn-primary {
  background: linear-gradient(
    135deg,
    var(--primary-color) 0%,
    var(--primary-dark) 100%
  );
  color: white;
  box-shadow: 0 3px 10px rgba(255, 149, 0, 0.3);
}

/* 调研入口 */
.survey-entry {
  position: fixed;
  bottom: 96px;
  right: 20px;
  z-index: 80;
  animation: bounce 2s ease-in-out infinite;
}

.survey-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-medium);
  cursor: pointer;
  transition: all 0.2s ease;
}

.survey-icon:active {
  transform: scale(0.92);
  box-shadow: var(--shadow-light);
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-8px);
  }
  60% {
    transform: translateY(-4px);
  }
}

/* 响应式设计 */
@media screen and (max-width: 320px) {
  .ticket-info {
    padding: 16px;
  }

  .entry-code-section {
    padding: 16px;
    margin: 12px;
  }

  .ticket-name {
    font-size: 16px;
  }

  .code-value {
    font-size: 16px;
    letter-spacing: 4px;
  }

  .btn {
    padding: 12px 14px;
    font-size: 15px;
    margin: 0 4px;
  }
}

@media screen and (min-width: 768px) {
  .ticket-entry-container {
    max-width: 500px;
    margin: 0 auto;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
    min-height: 100vh;
  }

  .bottom-actions {
    max-width: 500px;
    left: 50%;
    transform: translateX(-50%);
  }
}

/* 高对比度模式支持 */
@media (prefers-contrast: high) {
  :root {
    --shadow-light: 0 2px 8px rgba(0, 0, 0, 0.2);
    --shadow-medium: 0 4px 16px rgba(0, 0, 0, 0.3);
  }

  .back-btn,
  .copy-btn,
  .btn {
    border: 1px solid currentColor;
  }
}

/* 减少动画的偏好设置 */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }

  .survey-entry {
    animation: none;
  }
}

/* 触摸反馈增强 */
@media (hover: none) {
  .back-btn,
  .copy-btn,
  .btn,
  .survey-icon {
    touch-action: manipulation;
  }
}
</style>
